<template>
	<button id="resume">
	</button>
</template>

<script>
export default { name: 'PauseModal' }
</script>

<style lang="scss">
$button-size: 48px;
#resume {
	position: fixed;
	top: 50%;
	left: 50%;
	margin-left: -$button-size * .5;
	margin-right: -$button-size * .5;
	width: $button-size;
	height: $button-size;
	border-style: solid;
	border-width: $button-size * .5 0 $button-size * .5 $button-size;
	border-color: transparent transparent transparent #fff;
	background: none;
	cursor: pointer;
}
</style>
